import { render } from "./ListOfInvoices.vue?vue&type=template&id=8e91fbc4&scoped=true&ts=true"
import script from "./ListOfInvoices.vue?vue&type=script&lang=ts"
export * from "./ListOfInvoices.vue?vue&type=script&lang=ts"

import "./ListOfInvoices.vue?vue&type=style&index=0&id=8e91fbc4&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e91fbc4"]])

export default __exports__